export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            有好的影视资源推荐？遇到播放问题？欢迎随时与我们取得联系
          </p>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">邮箱联系</h3>
                <span className="text-xs text-foreground-500">contact@lulucinema.com</span>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-message-3-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">资源投稿</h3>
                <span className="text-xs text-foreground-500">submit@lulucinema.com</span>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-question-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">问题反馈</h3>
                <span className="text-xs text-foreground-500">support@lulucinema.com</span>
              </div>
            </div>

            {/* Contact hint */}
            <p className="text-xs text-foreground-400 leading-relaxed">
              我们的团队将在 24 小时内回复您的邮件。也可以在页面下方查看<strong>常见问题</strong>，快速找到答案。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}